import Router from './router/Router';
import { CssBaseline } from '@material-ui/core';

function App() {
  return (
    <>
      <CssBaseline />
      <Router />
    </>
  );
}

export default App;
